var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "input",
    class: { changed: _vm.changed, "disabled-input": _vm.disabled },
    attrs: { placeholder: _vm.placeholder, disabled: _vm.disabled },
    domProps: { value: _vm.value },
    on: {
      change: _vm.valueChanged,
      input: function($event) {
        _vm.$emit("input", $event.target.value)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62566185", { render: render, staticRenderFns: staticRenderFns })
  }
}